// extracted by mini-css-extract-plugin
export var container = "_bk-0";
export var containerTopRight = "_bk-1";